// extracted by mini-css-extract-plugin
module.exports = {"close":"_8aa2998","back":"_ead8edb","light":"_9a9e4db","float":"_32d9c62","arrow":"_c7ac706","pointer":"_986661b","body":"_978e037","footer":"_0a0a696"};